import script from "./SiteUnderConstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteUnderConstruction.vue?vue&type=script&setup=true&lang=js"

import "./SiteUnderConstruction.vue?vue&type=style&index=0&id=5d277d44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d277d44"]])

export default __exports__